// extracted by mini-css-extract-plugin
module.exports = {"BenefitsCalculatorList":"styles_BenefitsCalculatorList__keo-m","BenefitsCalculatorList_title":"styles_BenefitsCalculatorList_title__2dEVi"};